module.exports = __webpack_public_path__ + "static/media/new_wps_5.9acd8093.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/new_wps_5.jpg
// module id = 1906
// module chunks = 0